import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "leaveInvitationGroup",
  tabindex: "-1",
  "aria-labelledby": "leaveInvitationGroup",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "leaveInvitedGroup"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "text-center m-3 mx-3 text-name" }
const _hoisted_8 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_9 = {
  class: "modal fade",
  id: "leaveInvitationGroupSuccess",
  tabindex: "-1",
  "aria-labelledby": "leaveInvitationGroupSuccess",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "modal-dialog" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "leaveInvitedGroupSuccess"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_15 = { class: "text-center mt-4" }
const _hoisted_16 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    required: false,
    default: '',
  },
  leaveGroupSuccess: {
    type: Boolean,
    required: false,
    default: true,
  },
  displaySuccessModal: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  emits: ['leaveInvitationGroup'],
  setup(__props, { emit }) {

const props = __props





const leaveInvitationGroup = (): void => {
  emit('leaveInvitationGroup')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('leaveInvitationGroupModalTitle')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(`「${__props.name}」`), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(translate)('leaveInvitationGroupModalContent')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              type: "secondary",
              "data-bs-dismiss": "modal",
              class: "me-2",
              className: "fw-bold"
            }, null, 8, ["title"]),
            _createVNode(Button, {
              id: "leaveGroupButton",
              title: _unref(translate)('exit'),
              onClick: leaveInvitationGroup,
              dataBsToggle: __props.displaySuccessModal ? 'modal' : '',
              type: "secondary",
              "data-bs-dismiss": __props.displaySuccessModal ? '' : 'modal',
              dataBsTarget: __props.displaySuccessModal ? '#leaveInvitationGroupSuccess' : '',
              className: "fw-bold"
            }, null, 8, ["title", "dataBsToggle", "data-bs-dismiss", "dataBsTarget"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h5", _hoisted_13, _toDisplayString(_unref(translate)('leaveGroupConfirm1')), 1),
            _hoisted_14
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(__props.leaveGroupSuccess ? _unref(translate)('leaveInvitationGroupModalSuccess') : _unref(translate)('serverError3')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                type: "secondary",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                className: "fw-bold"
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})